import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaEnvelope, FaArrowLeft, FaUserCircle } from 'react-icons/fa';
import { supabase } from '../../supabaseClient';
import { fetchAuth } from '../../utils/api';

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const validateEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!validateEmail(email)) { setError('Ingresa un correo válido'); return; }
    setLoading(true);
    try {
      await fetchAuth('/api/auth/reset-password/send/', {
        method: 'POST',
        body: JSON.stringify({ email })
      });
      setLoading(false);
      setSuccess('Te enviamos un correo con el enlace para restablecer tu contraseña.');
    } catch (err) {
      setLoading(false);
      const redirectTo = `${window.location.origin}/reset-password`;
      const { error: jsErr } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
      if (jsErr) { setError('No se pudo enviar el correo'); return; }
      setSuccess('Te enviamos un correo con el enlace para restablecer tu contraseña.');
    }
  };

  return (
    <div className="login-page-container">
      <div className="bg-bubbles">
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>

      <motion.div
        className="relative bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 w-full max-w-md border border-white/20"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ zIndex: 10 }}
      >
        <Link 
          to="/login" 
          className="absolute -top-12 left-0 flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md hover:bg-white/20 text-white rounded-xl transition-all duration-300 border border-white/20"
        >
          <FaArrowLeft className="text-sm" />
          <span className="text-sm font-medium">Volver</span>
        </Link>

        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl shadow-lg shadow-orange-500/50 mb-4">
            <FaUserCircle size={48} color="#FFFFFF" />
          </div>
          <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-2">
            Commit<span className="text-orange-600">Flow</span>
          </h1>
          <p className="text-slate-600 font-medium">Recuperar contraseña</p>
          <p className="text-slate-500 text-sm mt-1">Ingresa tu correo y te enviaremos un enlace para restablecerla</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-red-700 text-sm font-medium mb-4">{error}</div>
        )}
        {success && (
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 text-emerald-700 text-sm font-medium mb-4">{success}</div>
        )}

        <form onSubmit={onSubmit} className="space-y-5">
          <div className="space-y-2">
            <label htmlFor="email" className="block text-sm font-semibold text-slate-700">Correo electrónico</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <FaEnvelope className="text-slate-400" />
              </div>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tucorreo@ejemplo.com"
                disabled={loading}
                className="w-full pl-12 pr-4 py-3 bg-slate-50 border border-slate-300 rounded-xl text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-6 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-xl shadow-lg shadow-orange-500/50 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? 'Enviando...' : 'Enviar enlace'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}